import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { isBulkActionEnabled } from "@/constants/constants";
export const BulkActionsDisabledTooltipFragment = graphql(`
  fragment BulkActionsDisabledTooltip on Item {
    collection {
      slug
    }
  }
`);
export function BulkActionsDisabledTooltip(t0) {
  const $ = _c(13);
  const {
    item: itemKey,
    collectionSlug: collectionSlugProp,
    disabled,
    children
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = itemKey && readFragment(BulkActionsDisabledTooltipFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  const collectionSlug = collectionSlugProp ?? item?.collection?.slug;
  const t = useTranslations("BulkActionsDisabledTooltip");
  let t2;
  if ($[2] !== t) {
    t2 = t("bulkActionsNotAvailable");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== collectionSlug || $[5] !== disabled) {
    t3 = disabled ? isBulkActionEnabled(collectionSlug) : true;
    $[4] = collectionSlug;
    $[5] = disabled;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <span>{children}</span>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Tooltip content={t2} disabled={t3}>{t4}</Tooltip>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}